import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, Button, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import ClientIndividual from './ClientIndividual';
import ClientCorporation from './ClientCorporation';
import { ADD, EDIT } from '../../../common/common';

const Root = styled(Box)({
    width: '801px',
    padding: '24px',
    backgroundColor: '#fff',
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .textWapper': {
        width: '100%',
        '& .title': {
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#212C31',
            marginTop: '18px',
        },
    },
    '& .notesText': {
        width: '100%',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#F3F3F3',
        margin: '20px 0',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
})

const INDIVIDUAL = "individual";
const CORPORATION = "corporation";
class Client extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            radioValue: "",
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleRadio = this.handleRadio.bind(this);
    }
    render() {
        const { data, state } = this.props;
        const { radioValue } = this.state;
        const checkInfo = () => {
            if (radioValue === INDIVIDUAL) {
                return <ClientIndividual
                    ref={(child) => { this.clientIndividual = child }}
                    state={state}
                    data={data}
                ></ClientIndividual>
            } else if (radioValue === CORPORATION) {
                return <ClientCorporation
                    ref={(child) => { this.clientCorporation = child }}
                    state={state}
                    data={data}
                ></ClientCorporation>
            }
        }
        return (
            <Root>
                <div className="pageTitle">
                    Dear Client, Please fill the info below, and click the SUBMIT button when you finish, thank you!
                </div>
                <div className="line"></div>
                <div className="textWapper">
                    <div className="title">Client Info</div>
                    <RadioGroup
                        aria-label="Gender"
                        name="gender1"
                        row
                        value={radioValue}
                        onChange={this.handleRadio}
                    >
                        <FormControlLabel disabled={true} value={INDIVIDUAL} control={<Radio color="primary" />} label="Individual" />
                        <FormControlLabel disabled={true} value={CORPORATION} control={<Radio color="primary" />} label="Corporation" />
                    </RadioGroup>
                    {checkInfo()}
                </div>
                <div className="line"></div>
                <div className="foot h h-r">
                    <Button variant="contained" color="primary" onClick={this.handleCreate}>submit</Button>
                </div>
            </Root>
        )
    }
    componentWillReceiveProps(nextProps) {
        this.setState(() => ({
            radioValue: nextProps.ICType
        }));
    }
    componentDidMount() {
        console.log("client componentDidMount")
        const { ICType } = this.props;
        console.log("client", ICType);
        this.setState(() => ({
            radioValue: ICType
        }));
    }
    handleRadio(e) {
        let radioValue = e.target.value;
        this.setState(() => ({
            radioValue
        }))
    }
    handleCreate() {
        const { radioValue } = this.state;
        let data = "";
        if (radioValue === INDIVIDUAL) {
            data = this.clientIndividual.handleGetData();
        } else if (radioValue === CORPORATION) {
            data = this.clientCorporation.handleGetData();
        }
        console.log("data")
        this.props.handleCreate(radioValue, data)
    }

    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
}

export default Client;